export enum NotificationActionTypes {
  NOTIFY_ERROR = 'NOTIFY_ERROR',
  SET_IS_LOADING = 'SET_IS_LOADING'
}

export interface NotifyErrorAction {
  type: NotificationActionTypes;
  payload: { message?: string };
}

export interface SetIsLoadingAction {
  type: NotificationActionTypes;
  payload: { isLoading: boolean };
}

export const notifyErrorAction = (message?: string): NotifyErrorAction => {
  return { type: NotificationActionTypes.NOTIFY_ERROR, payload: { message: message } };
};

export const setIsLoadingAction = (isLoading: boolean): SetIsLoadingAction => {
  return { type: NotificationActionTypes.SET_IS_LOADING, payload: { isLoading: isLoading } };
};
